import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M8.703 3.987a.75.75 0 0 0 1.06 1.06L11.25 3.56v5.471a.75.75 0 0 0 1.5 0v-5.47l1.486 1.486a.75.75 0 0 0 1.061-1.06L12.53 1.22a.75.75 0 0 0-1.06 0zM7.165 10.33a.75.75 0 0 1 1.006.335l.75 1.5a.75.75 0 0 1-1.342.67l-.75-1.5a.75.75 0 0 1 .336-1.006M9.691 16.047a5.25 5.25 0 0 1 7.54 4.267.75.75 0 0 0 1.495-.128 6.76 6.76 0 0 0-1.394-3.563 6.75 6.75 0 0 0-12.057 3.563.75.75 0 1 0 1.494.128 5.25 5.25 0 0 1 2.922-4.267M.75 22.25a.75.75 0 0 1 .75-.75h21a.75.75 0 0 1 0 1.5h-21a.75.75 0 0 1-.75-.75M2.586 15.58a.75.75 0 0 0-.671 1.34l1.5.75a.75.75 0 0 0 .67-1.34zM22.086 16.92a.75.75 0 0 0-.671-1.34l-1.5.75a.75.75 0 0 0 .67 1.34zM17.171 11.336a.75.75 0 0 0-1.342-.671l-.75 1.5a.75.75 0 0 0 1.342.67z" />
  </>
);

const Sunrise = Icon('sunrise', svgContents);

export default Sunrise;
